module.exports = __webpack_public_path__ + "img/预留.0f6958f3.webp";